export default __webpack_public_path__ + "static/media/daily_status_table_sample.f617ea11.png";